/**
 * RP-4233 — the two item fields, read with the transitional rules.
 *
 * `itemsDescription` is the list the API computes from `items` ("2 x Sofa (XL), …") on every
 * cart write. `donationItems` is the donor's or agent's own words, never computed any more.
 * Records written before the split carry the list in `donationItems` too — alone when the donor
 * typed nothing, or followed by the donor's words with a copy of those words in
 * `meta.donationItemsUser`. Hence the two legacy branches below; drop them once pre-split
 * donations have aged out. Mirrors resolveDonationItems in resupply-master (packages/ui).
 */
export interface DonationItemFields {
  donationItems?: string | null;
  itemsDescription?: string | null;
  meta?: { donationItemsUser?: string | null } | null;
}

/** The shape only the API's list builder produces: "2 x Sofa (XL), 1 x Lamp (S)". */
const COMPUTED_LIST_PATTERN = /^\d+ x .+ \((S|M|L|XL)\)(, \d+ x .+ \((S|M|L|XL)\))*$/;

export function resolveDonationItems(donation: DonationItemFields | null | undefined): { list: string; description: string } {
  const list = (donation?.itemsDescription ?? '').trim();
  const raw = (donation?.donationItems ?? '').trim();
  const legacyUserText = (donation?.meta?.donationItemsUser ?? '').trim();

  let description = raw;
  if (legacyUserText && raw.endsWith(legacyUserText)) {
    description = legacyUserText; // an untouched pre-split merge: the meta copy is exactly the donor's words
  } else if (raw === list || COMPUTED_LIST_PATTERN.test(raw)) {
    description = ''; // a pre-split copy of the list (current or since outdated), not a description
  }

  return { list, description };
}
